import { Component, OnInit } from '@angular/core';
import { LookupService } from '../../services/lookups/lookup.service';
import { User,UserType } from '../../models/user.model';
import { RegistrationService } from '../../services/registration.service';
import { NotifierService } from 'angular-notifier';


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {
  statusSelected: string;
  users: User[];
  usersTemp: User[];
   userType: UserType;
  // lookup data
  userTypes: UserType[];
  userstatusSelected: string;
  lastName: string ;
  firstName: string ;

  //lastName: string;
  constructor(
    private _lookupService: LookupService,
    private _registrationService: RegistrationService,
    private _notifier: NotifierService
  ) {}

  ngOnInit() {
    this.statusSelected = 'Pending';
    this.getPendingHqUsers();   

    this._lookupService.getUserTypes().subscribe((data: UserType[]) => {    
    this.userTypes =data.filter(type => type.typeName !== 'Unknown');       
    }); 
  }

  search()
  {    
      this.users=this.usersTemp;
      if (this.firstName!=undefined )
      {
        this.users= this.users.filter(u =>u.firstName.toLowerCase().indexOf(this.firstName.toLowerCase())!== -1);
      }
      if (this.lastName!=undefined)
      {
        this.users= this.users.filter(u =>u.lastName.toLowerCase().indexOf(this.lastName.toLowerCase())!== -1);
      }
      if (this.userType!=null )
      {
        this.users= this.users.filter(u =>u.userType.id===this.userType.id);
      } 
  }
      onReset()
      {
        this.lastName='';
        this.firstName='';
        if (this.userType!=undefined )
          {
             this.userType=this.userType[0];
          }
        this.users=this.usersTemp;

      }
  onStatusSelection() {
      this.lastName='';
      this.firstName='';        
     this.userType=undefined;//this.userType[0];

    if (this.statusSelected === 'Active') {
      this.getActiveUsers();
    } else if(this.statusSelected === 'Pending'){
      this.getPendingHqUsers();
    }
    else
    {
      this.getDeactiveUsers();
    }
  }

 getActiveUsersSearch(userstatusSelected: string,lastName: string) {
    this._lookupService.getAllActiveUsers$().subscribe((users: User[]) => {
      this.users = users;      
    });
  }

  getActiveUsers() {
    this._lookupService.getAllActiveUsers$().subscribe((users: User[]) => {
      this.usersTemp = users;
      this.users = users;
    });
  }

  
    getDeactiveUsers() {
    this._lookupService.getAllDeActiveUsers$().subscribe((users: User[]) => {
      this.usersTemp = users;
      this.users = users;
    });
  }

  getPendingHqUsers() {
    this._lookupService.getPendingHqUsers$().subscribe((users: User[]) => {
       this.usersTemp = users;
       this.users = users;
    });
  }
  reload(val:boolean)
  {
    if(val)
    {
     
      if (this.statusSelected === 'Active') {
        this.getActiveUsers();
      } else if(this.statusSelected === 'Pending'){
        this.getPendingHqUsers();
      }
      else
      {
        this.getDeactiveUsers();
      }
    }
  }

  activateUser(userToActivate: User) {
    this._registrationService.activateUser(userToActivate.id).subscribe(response => {
      if (response.ok) {
        this.onStatusSelection();
        this._notifier.notify('success', 'User activated successfully.');
      }
    });
  }

  deactivateUser(userToDeactivate: User) {
    this._registrationService.deactivateUser(userToDeactivate.id).subscribe(response => {
      if (response.ok) {
        this.onStatusSelection();
        this._notifier.notify('success', 'User deactivated successfully.');
      }
    });
  }
}

// export class RadioButtonDemo {
//   val1: string;

//   val2: string = 'Option 2';
// }
